// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X9jR","delete":"styles_delete__LvNVD","update":"styles_update__3T88F","add":"styles_add__2FoeT"};